"use client";

import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import AOS from "aos";
import "aos/dist/aos.css";
// Also ensure these are imported somewhere globally:
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

import banner1 from "../../assets/images/banner1.jpg";
import banner2 from "../../assets/images/banner2.jpg";
import banner3 from "../../assets/images/banner3.jpg";
// import getIcon from "../../helper/getIcon"; // if you re-enable arrows

const BannerThree = () => {
  const sliderRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false); // keep if you later add a modal

  // Safety: refresh AOS after mount
  useEffect(() => {
    const t = setTimeout(() => AOS.refresh(), 100);
    return () => clearTimeout(t);
  }, []);

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 900,
    dots: false,
    pauseOnHover: true,
    arrows: false, // set true if you want arrows
    draggable: true,
    infinite: true,
    fade: true,
    afterChange: () => AOS.refresh(),
  };

  return (
    <section className="banner-three position-relative responsive-arrow overflow-hidden">
      {/* Uncomment if you want arrows
      <button
        type="button"
        onClick={() => sliderRef.current?.slickPrev()}
        className="slick-arrow-prev ..."
        aria-label="Previous slide"
      >
        {getIcon("bs-arrow-left")}
      </button>
      <button
        type="button"
        onClick={() => sliderRef.current?.slickNext()}
        className="slick-arrow-next ..."
        aria-label="Next slide"
      >
        {getIcon("bs-arrow-right")}
      </button>
      */}

      <Slider ref={sliderRef} {...settings} className="banner-three__slider">
        {/* Slide 1 */}
        <div>
          <div
            className="banner-three__item background-img bg-img position-relative"
            style={{ backgroundImage: `url(${banner1})` }}
          >
            <div className="container">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 z-1">
                  <div
                    className="banner-content pe-md-4 text-center"
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    <div className="flex-align justify-content-center gap-8 mb-16">
                      <h5 className="text-yellow-600 mb-0 fw-medium">
                        Welcome to NPS, Kudlu
                      </h5>
                    </div>
                    <h2
                      className="display2 mb-24 text-white fw-medium"
                      data-aos="fade-left"
                      data-aos-delay="100"
                    >
                      A Place to Learn,
                      <span
                        className="text-yellow-600"
                        data-aos="fade-right"
                        data-aos-delay="250"
                      >
                        &nbsp;Grow&nbsp;
                      </span>
                      &amp; Shine
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slide 2 */}
        <div>
          <div
            className="banner-three__item background-img bg-img position-relative"
            style={{ backgroundImage: `url(${banner2})` }}
          >
            <div className="container">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 z-1">
                  <div
                    className="banner-content pe-md-4 text-center"
                    data-aos="fade-up"
                  >
                    <h2
                      className="display2 mb-24 text-white fw-medium"
                      data-aos="fade-left"
                      data-aos-delay="120"
                    >
                      Nurturing Young Minds,
                      <span
                        className="text-yellow-600"
                        data-aos="fade-right"
                        data-aos-delay="250"
                      >
                        &nbsp;Building&nbsp;
                      </span>
                      Bright Futures
                    </h2>
                  </div>
                  <div className="buttons-wrapper flex-align flex-wrap gap-24 mt-40" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slide 3 */}
        <div>
          <div
            className="banner-three__item background-img bg-img position-relative"
            style={{ backgroundImage: `url(${banner3})` }}
          >
            <div className="container">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 z-1">
                  <div
                    className="banner-content pe-md-4 text-center"
                    data-aos="fade-up"
                  >
                    <h2
                      className="display2 mb-24 text-white fw-medium"
                      data-aos="fade-left"
                      data-aos-delay="120"
                    >
                      Education with Values,
                      <span
                        className="text-yellow-600"
                        data-aos="fade-right"
                        data-aos-delay="250"
                      >
                        &nbsp;Excellence&nbsp;
                      </span>
                      with Care
                    </h2>
                  </div>
                  <div className="buttons-wrapper flex-align flex-wrap gap-24 mt-40" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Slider>
    </section>
  );
};

export default BannerThree;
